import styled, {css} from 'styled-components';
import {Color} from '../../tokens/colors';
import {Radius} from '../../tokens/radiuses';

const StatusCode = {
    DEFAULT: 'default',
    WAITING_MATERIAL: 'waitingMaterial',
    IN_PRODUCTION: 'inProduction',
    READY: 'ready',
    ISSUED: 'issued',
    CANCELED: 'canceled',
    SUB_FOR_DELIVERY: 'subForDelivery',
    IN_PROGRESS: 'inProgress',
    READY_TO_RECEIVE: 'readyToReceive',
};

const statusColor = {
    white: {
        text: Color.BLACK,
        background: Color.WHITE,
        border: Color.BLACK,
    },
    red: {
        text: '#cd161d',
        background: '#fbefef',
        border: '#efb4b6',
    },
    blue: {
        text: '#18458f',
        background: '#eaeef5',
        border: '#90a5c9',
    },
    green: {
        text: '#2c7800',
        background: '#f1f6eb',
        border: '#c7dbb0',
    },
    gray: {
        text: '#575757',
        background: '#eeeeee',
        border: '#cacaca',
    },
    yellow: {
        text: '#EAC43D',
        background: '#FFF9E5',
        border: '#ecd695',
    },
};

const StatusCodeToCSS = {
    [StatusCode.DEFAULT]: css`
        color: ${statusColor.white.text};
        background-color: ${statusColor.white.background};
        border-color: ${statusColor.white.border};
    `,
    [StatusCode.WAITING_MATERIAL]: css`
        color: ${statusColor.red.text};
        background-color: ${statusColor.red.background};
        border-color: ${statusColor.red.border};
    `,
    [StatusCode.IN_PRODUCTION]: css`
        color: ${statusColor.blue.text};
        background-color: ${statusColor.blue.background};
        border-color: ${statusColor.blue.border};
    `,
    [StatusCode.READY]: css`
        color: ${statusColor.green.text};
        background-color: ${statusColor.green.background};
        border-color: ${statusColor.green.border};
    `,
    [StatusCode.READY_TO_RECEIVE]: css`
        color: ${statusColor.green.text};
        background-color: ${statusColor.green.background};
        border-color: ${statusColor.green.border};
    `,
    [StatusCode.ISSUED]: css`
        color: ${statusColor.green.text};
        background-color: ${statusColor.green.background};
        border-color: ${statusColor.green.border};
    `,
    [StatusCode.CANCELED]: css`
        color: ${statusColor.red.text};
        background-color: ${statusColor.red.background};
        border-color: ${statusColor.red.border};
    `,
    [StatusCode.SUB_FOR_DELIVERY]: css`
        color: ${statusColor.blue.text};
        background-color: ${statusColor.blue.background};
        border-color: ${statusColor.blue.border};
    `,
    [StatusCode.IN_PROGRESS]: css`
        color: ${statusColor.yellow.text};
        background-color: ${statusColor.yellow.background};
        border-color: ${statusColor.yellow.border};
    `,
};

const StyledStatus = styled.div.attrs(({code}) => ({
    code: code || StatusCode.DEFAULT,
}))`
    ${({code}) => StatusCodeToCSS[code]}

    display: inline-flex;
    align-items: center;
    padding: 5px 9px 4px;
    text-align: center;
    font-weight: 700;
    font-size: 12px;
    line-height: 1.2;
    text-transform: ${(props) => (props.isUppercase ? 'uppercase' : 'none')};
    border-width: 1px;
    border-style: solid;
    border-radius: ${Radius.BUTTON};
`;

export {StyledStatus as Status, StatusCode};
